/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a8730a15922878a121ac11adc42462d3c5eefb05";
